var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVine7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m2322,204.5c0,0 -667.5,-340 -1030,-2.5c-362.5,337.5 -595,-175 -377.5,-252.5c217.5,-77.5 757.5,-405 395,-390c-362.5,15 -930,-355 -1127.5,95c-197.5,450 317.5,-87.5 77.5,432.5c-240,520 -182.5,855 -135,1032.5c47.5,177.5 145,295 273,293c128,-2 177,-63 242.5,-142.5c65.5,-79.5 187,-243 240,-307.5c53,-64.5 142,-193 265,-265c123,-72 317,-148 525,-142.5c208,5.5 257,12 460,105c203,93 249.5,239.5 247.5,237.5c-2,-2 404.5,799.5 402.5,547.5c-2,-252 297,-483 295,-485c-2,-2 -0.5,-390.5 -3,-415.5c-2.5,-25 -40,-462.5 -40,-465c0,-2.5 -320,657.5 -322,655.5c-2,-2 -153,-373 -155,-375c-2,-2 277,-335.5 275,-337.5c-2,-2 -508,182 -508,182z",
    fill: "none",
    id: "vinePath",
    stroke: "#047655",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVine7);
export default __webpack_public_path__ + "static/media/vine7.cc1dfed6f1ecb206a9957f92348e8f3d.svg";
export { ForwardRef as ReactComponent };